
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Microsoft YaHei", sans-serif;
}
</style>

<!--
<template>
  <div class="container">
    <CommonSidebar />
    <div class="main">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import CommonSidebar from '@/components/CommonSidebar.vue'
</script>
-->